import React from "react";
import { useSelector } from "react-redux";
import { replaceFloatValue } from "utils/replaceFloatValue";
import { MODAL_CLOSE} from "src/constants/images";

import Modal from "./Modal";

const BuyConfirmModal = ({
  isVisible,
  onCancel,
  onConfirm,
  icxAmount,
  name,
}) => {
  const icxInUSD = useSelector((state) => state.icxPricing.price);

  const handleBuy = () => {
    onConfirm();
    onCancel();
  };

  return (
    <Modal
      isVisible={isVisible}
      overlayClass="overlay"
      className="disconnect-modal card p-4"
    >
      <div className="heading">
        <h4 className="mb-1">Are You Sure?</h4>
        <p className="text pt-3">
          Buy <strong>{name}</strong> for <strong>{icxAmount} ICX</strong> ($
          {replaceFloatValue(icxAmount * icxInUSD)})?</p>
        <div className="body d-flex justify-content-center pt-4 me-4 mb-0">
          <button
            className="btn btn-outline-secondary mx-2 close"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button className="btn btn-primary continue" onClick={handleBuy}>
            Confirm
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default BuyConfirmModal;
